// src/pages/Dashboard.tsx
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import Search from "./Search";
import ProspectsDrawer from "./ProspectsDrawer";
import type { LinkedInProspectResponse } from "../types/prospects";
import { getLinkedInProspects } from "../api";

export default function Dashboard() {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.name) {
      const firstName = user.name.split(" ")[0];
      document.title = `${firstName}'s Dashboard • BacklinkBanana`;
    } else {
      document.title = "Dashboard • BacklinkBanana";
    }
  }, [user]);

  const [prospectsOpen, setProspectsOpen] = useState(false);
  const [prospectsLoading, setProspectsLoading] = useState(false);
  const [prospectsError, setProspectsError] = useState<string | null>(null);
  const [prospectsData, setProspectsData] = useState<LinkedInProspectResponse | null>(null);

  // Accept domain OR full URL from <Search />
  const openProspects = useCallback(async (domainOrUrl: string) => {
    setProspectsOpen(true);
    setProspectsLoading(true);
    setProspectsError(null);
    setProspectsData(null);
    try {
      // you can tweak limit later (backend caps upstream to 10 anyway)
      const data = await getLinkedInProspects(domainOrUrl, { limit: 12 });
      // { domain, brand, linkedin_company_url, prospects: [...] }
      setProspectsData(data);
    } catch (e: any) {
      setProspectsError(e?.message || "Failed to fetch prospects.");
    } finally {
      setProspectsLoading(false);
    }
  }, []);

  const closeProspects = useCallback(() => {
    setProspectsOpen(false);
    setProspectsError(null);
    setProspectsData(null);
  }, []);

  if (!user)
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-100 to-white flex items-center justify-center">
        <div className="text-center text-lg text-gray-600">Loading profile...</div>
      </div>
    );

  return (
<div className="min-h-screen bg-white flex flex-col justify-between pb-16">
<div className="flex-1 w-full">
  <div className="w-full">
    {/* onOpenProspects can pass domain OR a full page URL */}
    <Search onOpenProspects={openProspects} />
  </div>
</div>




      <footer className="mt-8 text-gray-500 text-xs text-center px-4">
        <div className="space-x-4 mb-2">
          <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
          <span>|</span>
          <a href="/terms-and-conditions" className="hover:underline">Terms &amp; Conditions</a>
        </div>
        &copy; {new Date().getFullYear()} Backlink Banana
      </footer>

      <ProspectsDrawer
        open={prospectsOpen}
        loading={prospectsLoading}
        error={prospectsError}
        data={prospectsData}
        onClose={closeProspects}
      />
    </div>
  );
}
